import React, { useState , useEffect} from 'react';

import { useNotification } from 'config/Notification';

import { fetchAuditTrailDetailsByAssessment as fetchAuditTrailDetailsByAssessmentService } from 'services/modules/cap/standardservice';

import CloseIcon from '@mui/icons-material/Close';
// import ArrowRightIcon from '@mui/icons-material/ArrowRight';  //TE for AuditTrialPage UI beautification commented prev code

// code change for audit description
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from '@mui/material';

const AuditTrialPage = ({toggleAuditTrial,assessmentId}) => {
  
  // Notification
  const {openNotification} = useNotification();

  // State variables
  const [auditTrailDetails,setAuditTrailDetails]=useState({});
  const [loading,setLoading]=useState(false);
  const [show,setShow] = useState(true);
  // code change for audit description
  const [expandedIndex, setExpandedIndex] = useState(null);

  //TE for AuditTrialPage for time stamp format start
  // Utility function to format date with time
  const formatDateTime = (dateValue) => {
    if (!dateValue) return "";

    const dateObj = new Date(dateValue);

    return dateObj.toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, // change to false if 24-hour format is required
    });
  };
  // Function to format only time
const formatTime = (dateValue) => {
  if (!dateValue) return "";

  const dateObj = new Date(dateValue);

  return dateObj.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

//Function to get initials
const getInitials = (name) => {
  if (!name) return "";

  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .substring(0,2)
    .toUpperCase();
};
// code change for summary remarks in audit description
const getDescription = (record) => {
  const user = auditTrailDetails.user?.name || "User";
  const admin = auditTrailDetails.superuser?.name || "Admin";
  const standard = auditTrailDetails?.standard_name || "Assessment";

  let line1 = "";
  let remarks = "";

  switch (record.activity) {
    case "Assessment submitted":
      line1 = `${standard} assessment submitted by ${user} to ${admin}`;
      break;

    case "Assessment approved":
      line1 = `${standard} assessment approved by ${admin}`;
      remarks = auditTrailDetails.approval_remarks;
      break;

    case "Assessment rejected":
      line1 = `${standard} assessment rejected by ${admin}`;
      remarks = auditTrailDetails.overall_rejection_remarks;
      break;

    case "Assessment created":
      line1 = `${standard} assessment created by ${admin}`;
      break;

    case "Mitigation suggested":
      line1 = `${standard} mitigation plan suggested by ${admin}`;
      break;

    case "Mitigation response submitted":
      line1 = `${standard} mitigation response submitted by ${user}`;
      break;

    case "Mitigation response rejected":
      line1 = `${standard} mitigation response rejected by ${admin}`;
      break;

    case "Mitigation approved (Assessment completed)":
      line1 = `${standard} assessment completed and mitigation approved by ${admin}`;
      break;

    default:
      line1 = "";
      break;
  }

  const formattedDate = new Date(record.datetime).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric"
  });
  const line2 = `On ${formattedDate} at ${formatTime(record.datetime)}`;

  return { line1, line2, remarks };
};
  //TE for AuditTrialPage for time stamp format end
  
  useEffect(() => {
    getAuditTrailDetailsByAssessment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
  
  // MEthod handles to fetch the AuditTrail details based on the assessment id.
  const getAuditTrailDetailsByAssessment=async ()=> {
    try{
      setLoading(true);
      setAuditTrailDetails({});
      let params = {assessmentid:assessmentId};
      let auditResponse = await fetchAuditTrailDetailsByAssessmentService({ params });
      if(auditResponse.data){
        setAuditTrailDetails(auditResponse.data);
      }
    }catch(e){
      openNotification('Error while fetching audit trail details','error');
    }finally{
      setLoading(false);
    }
  };
  // TE for AuditTrialPage UI beautification start
  // Build timeline records from auditTrailDetails
const timelineRecords = [];

if (auditTrailDetails.createdAt) {
  timelineRecords.push({
    activity: "Assessment created",
    datetime: auditTrailDetails.createdAt,
    user: auditTrailDetails.superuser?.name,
    role: "Superuser"
  });
}

if (auditTrailDetails.assessment_submitted_date) {
  timelineRecords.push({
    activity: "Assessment submitted",
    datetime: auditTrailDetails.assessment_submitted_date,
    user: auditTrailDetails.user?.name,
    role: "User"
  });
}

if (auditTrailDetails.assessment_rejected_date) {
  timelineRecords.push({
    activity: "Assessment rejected",
    datetime: auditTrailDetails.assessment_rejected_date,
    user: auditTrailDetails.superuser?.name,
    role: "Superuser"
  });
}

if (auditTrailDetails.approved_date) {
  timelineRecords.push({
    activity: "Assessment approved",
    datetime: auditTrailDetails.approved_date,
    user: auditTrailDetails.superuser?.name,
    role: "Superuser"
  });
}

if (auditTrailDetails.mitigation_date) {
  timelineRecords.push({
    activity: "Mitigation suggested",
    datetime: auditTrailDetails.mitigation_date,
    user: auditTrailDetails.superuser?.name,
    role: "Superuser"
  });
}

if (auditTrailDetails.mitigation_response_date) {
  timelineRecords.push({
    activity: "Mitigation response submitted",
    datetime: auditTrailDetails.mitigation_response_date,
    user: auditTrailDetails.user?.name,
    role: "User"
  });
}

if (auditTrailDetails.mitigation_rejected_date) {
  timelineRecords.push({
    activity: "Mitigation response rejected",
    datetime: auditTrailDetails.mitigation_rejected_date,
    user: auditTrailDetails.superuser?.name,
    role: "Superuser"
  });
}

if (auditTrailDetails.status === "Completed") {
  timelineRecords.push({
    activity: "Mitigation approved (Assessment completed)",
    datetime: auditTrailDetails.approved_date,
    user: auditTrailDetails.superuser?.name,
    role: "Superuser"
  });
}
// Sort timeline records by datetime
// timelineRecords.sort((a, b) => new Date(a.datetime) - new Date(b.datetime));
  // TE for AuditTrialPage UI beautification end
  
  return (
    <div>
      {/* <Dialog onClose={()=> setShow(false)} open={show}> //TE for Audit Trial Width increasing commenting prev line to replace with follows */}
      {/* //TE for Audit Trial Width increase start */}
      <Dialog
        open={show}
        onClose={() => setShow(false)}
        maxWidth="lg" //"md"
        fullWidth
      >
        {/* //TE for Audit Trial Width increase end */}
        {/* //TE for AuditTrial UI beautification commenting following prev code to replce with follows */}
        {/* <DialogTitle sx={{ m: 0, p: 2 }} >
          <h4 className='audit-trail-popuptext heading-popup'>Audit Trail</h4>
          <label className='audit-trail-popuptext'>Report id: {assessmentId}</label>
        </DialogTitle> */}
        {/* //TE for AuditTrial UI beautification start */}
        <DialogTitle className="audit-header">

  <div className="audit-header-top">
    <span className="audit-eyebrow">CAP SELF ASSESSMENT</span>
  </div>

  <div className="audit-header-middle">
    <h3 className="audit-title">Audit Trail</h3>
    <span className="audit-count">{timelineRecords.length} records</span>
  </div>

  <div className="audit-header-bottom">
    Assessment ID : {assessmentId}
  </div>

</DialogTitle>
        {/* //TE for AuditTrial UI beautification end */}
        
        <IconButton
          onClick={()=> setShow(false)}
          sx={{
            position: 'absolute',
            right: 16,
            top: 16,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          {loading ? (
            <div className='txt-c p-10'>
              <CircularProgress />
            </div>
          ) : (
            //TE for AuditTrial beautification commented prev following 2 lines of code
            // <Typography gutterBottom>
              
            // </Typography>
            //TE for AuditTrialPage UI beautification start
            <div className="timeline">

{timelineRecords.map((record, index) => (

<div className="timeline-item" key={index}>

<div className="timeline-left">

<div className="timeline-date">
{new Date(record.datetime).toLocaleDateString("en-IN", {
  day: "2-digit",
  month: "short",
  year: "numeric"
})}
</div>

<div className="timeline-dot">●</div>

</div>



{/* code change for audit description*/}
<div className="timeline-card">

  {/* Header with arrow */}
  <div className="card-header">

    <div className="card-activity">
      {record.activity}
    </div>

    <div
      className="expand-icon"
      onClick={() =>
        setExpandedIndex(expandedIndex === index ? null : index)
      }
      style={{ cursor: "pointer" }}
    >
      <KeyboardArrowDownIcon
        style={{
          transform: expandedIndex === index ? "rotate(180deg)" : "rotate(0deg)",
          transition: "0.2s"
        }}
      />
    </div>

  </div>

{/* <div className="card-meta">
<span>{record.user}</span>
</div> */}



{/* <div className="card-meta">

  <div>
    <span>{record.user}</span>
    <span className="role-tag">{record.role}</span>
  </div>

  <span className="time-text">
    {formatTime(record.datetime)}
  </span>

</div> */}
{/* //TE for AuditTrial UI beautification above code replaced by below code change 2 */}
<div className="card-meta">

  <div className="user-info">

    <div className="avatar">
      {getInitials(record.user)}
    </div>

    <span className="user-name">
      {record.user}
    </span>

    <span className="role-tag">
      {record.role}
    </span>

  </div>

  <span className="time-text">
    {formatTime(record.datetime)}
  </span>

</div>
{/* //TE for AuditTrial UI beautification end */}
{/* code change for summary remarks in audit description */}
{expandedIndex === index && (() => {
  const desc = getDescription(record);
  return (
    <div className="card-description">
      <div>{desc.line1}</div>
      <div>{desc.line2}</div>
      {desc.remarks && (
        <div><strong>Remarks:</strong> {desc.remarks}</div>
      )}
    </div>
  );
})()}
</div>


</div>

))}

</div>
            //TE for AuditTrialPage UI beautification end

          )}
        </DialogContent>
      </Dialog>
    </div>
  )
}


export default AuditTrialPage;